<template>
  <base-input class="mt25"
              type="number"
              v-model="cutleryQty"
              @blur="$v.cutleryQty.$touch()"
              :placeholder="$t('Number of cutlery *')"
              :validations="[{
                condition: this.$v.cutleryQty.$error && !this.$v.cutleryQty.required,
                text: this.$t('Field is required')
              }]"
  />
</template>

<script>
import { unicodeAlphaNum } from '@vue-storefront/core/helpers/validators'
import { required } from 'vuelidate/lib/validators'

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  components: {
    BaseInput
  },

  props: {
    partnerCode: {
      type: [String],
      required: true
    }
  },

  data () {
    return {
      cutleryQty: 1
    }
  },

  mounted () {
    this.$store.state.checkout.cutleryQty = JSON.parse(localStorage.getItem('shop/checkoutFieldValues/cutlery-qty'))
    if (this.$store.state.checkout.cutleryQty) {
      let cutlery = this.$store.state.checkout.cutleryQty.find(item => item.partner === this.partnerCode)
      if (cutlery) {
        this.cutleryQty = cutlery.qty
      }
    }
  },

  watch: {
    cutleryQty: {
      deep: true,
      handler: function () {
        this.$bus.$emit(
          'checkout-after-cutleryQty',
          this.cutleryQty,
          this.partnerCode
        )
      }
    }
  },

  validations () {
    return {
      cutleryQty: {
        required,
        unicodeAlphaNum
      }
    }
  }
}
</script>
